import React, { useEffect, useState } from 'react'
import { ReactComponent as InfoIcon } from '../../../assets/svg/InfoIcon.svg'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Checkbox } from '../../../assets/svg/Checkbox.svg'
import CheckedCheckbox from './components/CheckedCheckbox'
import { emotions_heads, getPrimaryUndesirableEmotions, getUndesirableEmotions } from '../../../constants/Constants'
import RadioOptions from './components/RadioOptions'
import InfoButton from '../../common/InfoButton'
import { useUser } from '../../../auth'

const TriggersSection = ({ settings, save }) => {
    const { t } = useTranslation()
    const [emotionAmount, setEmotionAmount] = useState([2, 3, 4, 5, 6, 7, 8])
    const [selectedEmotionAmount, setSelectedEmotionAmount] = useState(settings?.multipleNegativeEmotionsTriggers?.numberOfEmotionsInRow)
    const [selectedEmotionOptions, setSelectedEmotionOptions] = useState(settings?.multipleNegativeEmotionsTriggers?.emotions)
    const emotions = getUndesirableEmotions()
    const primaryEmotions = getPrimaryUndesirableEmotions()
    const { user } = useUser()
    const showPrimaryEmotions = !!user?.hasPrimaryClasses

    useEffect(() => {
        if (!!settings) {
            setSelectedEmotionAmount(settings?.multipleNegativeEmotionsTriggers?.numberOfEmotionsInRow ?? 3)
            setSelectedEmotionOptions(settings?.multipleNegativeEmotionsTriggers?.emotions ?? [])
        }
    }, [settings])

    const selectNumberOfEmotions = (value) => {
        const data = {
            ...settings,
            multipleNegativeEmotionsTriggers: {
                ...settings.multipleNegativeEmotionsTriggers,
                numberOfEmotionsInRow: value,
            },
        }
        save(data)
        setSelectedEmotionAmount(value)
    }

    const handleSelection = (option) => {
        const current = selectedEmotionOptions ?? []
        const newEmotionsArray = current.includes(option) ? current.filter((item) => item !== option) : [...current, option]

        setSelectedEmotionOptions(newEmotionsArray)

        const data = {
            ...settings,
            multipleNegativeEmotionsTriggers: {
                ...settings.multipleNegativeEmotionsTriggers,
                emotions: newEmotionsArray,
            },
        }
        save(data)
    }
    return (
        <div className="rounded-[10px] w-full h-full p-[32px] bg-white">
            <div>
                <div className="flex flex-row justify-between">
                    <p className="font-bold text-[24px] leading-[30px] text-darkenPurple">{t('Uncomfortable emotions triggers')}</p>
                    <InfoButton text={t('Manage how many times uncomfortable emotions need to appear before triggering an alert, and choose which emotions to track')} />
                </div>
                <p className="text-darkenPurple font-medium text-[16px] leading-5 mt-[12px] max-w-[50%]">
                    {t('Choose how many times a student must select an uncomfortable emotion before an alert is triggered, and select which emotions you want to track')}
                </p>
            </div>
            <div className="flex flex-row justify-between">
                <div className="mt-[34px]">
                    <div className="flex flex-row gap-[10px]">
                        <p className="font-bold text-darkenPurple">{t('Number of emotions to trigger an alert')}</p>
                        <InfoButton text={t('Select how many days in a row a student must log uncomfortable emotions before an alert is sent')} />
                    </div>
                    <div className="flex flex-row items-center mt-[24px]">
                        <RadioOptions options={emotionAmount} value={selectedEmotionAmount} onClick={selectNumberOfEmotions} />
                    </div>
                </div>
                <div className="mt-[34px] max-w-[60%] flex-1">
                    <div className="flex flex-row items-center gap-[10px]">
                        <p className="font-bold text-darkenPurple">{t('Emotions to track')}</p>
                        <InfoButton text={t('Choose which specific uncomfortable emotions will be monitored for alerts')} />
                    </div>
                    <div className="grid grid-cols-2 gap-x-[84px] gap-y-5 mt-[24px]">
                        {emotions.map((option, index) => (
                            <div key={index} className="flex flex-row items-center gap-[20px]">
                                <CheckedCheckbox
                                    checked={selectedEmotionOptions?.includes(option.id)}
                                    text={option.text}
                                    icon={emotions_heads[option.id] || emotions_heads.default}
                                    onClick={() => handleSelection(option.id)}
                                    subText={option.subText}
                                />
                            </div>
                        ))}
                    </div>
                    {showPrimaryEmotions && (
                        <div className="mt-[34px]">
                            <div className="flex flex-row items-center gap-[10px]">
                                <p className="font-bold text-darkenPurple">{t('Upstrive Early emotions to track')}</p>
                                <InfoButton text={t('Uncomfortable emotions that students in primary (Upstrive Early) classes can choose')} />
                            </div>
                            <p className="text-darkenPurple font-medium text-[14px] leading-5 mt-[8px]">
                                {t('Sadness and Anger above also apply to Upstrive Early classes')}
                            </p>
                            <div className="grid grid-cols-2 gap-x-[84px] gap-y-5 mt-[24px]">
                                {primaryEmotions.map((option) => (
                                    <div key={option.id} className="flex flex-row items-center gap-[20px]">
                                        <CheckedCheckbox
                                            checked={selectedEmotionOptions?.includes(option.id)}
                                            text={option.text}
                                            icon={emotions_heads[option.id] || emotions_heads.default}
                                            onClick={() => handleSelection(option.id)}
                                            subText={option.subText}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default TriggersSection
